$(document).ready(function(){

    // init controller
    var controller = new ScrollMagic.Controller();   
    
    new ScrollMagic.Scene({triggerElement: "#strategic-location", reverse: false})
        .setClassToggle(".ico-marker", "animate")
        // .addIndicators({name: "sticky"})
        .addTo(controller);

});
